import React, { useEffect, useRef } from 'react';

const FloatingParticles = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef?.current;
    if (!container) return;

    const particles = [];
    const particleCount = 50;

    // Create particles
    for (let i = 0; i < particleCount; i++) {
      const particle = document.createElement('div');
      particle.className = 'absolute w-1 h-1 bg-accent/30 rounded-full pointer-events-none';
      
      // Random initial position
      particle.style.left = Math.random() * 100 + '%';
      particle.style.top = Math.random() * 100 + '%';
      
      // Random animation duration and delay
      const duration = 8 + Math.random() * 12; // 8-20 seconds
      const delay = Math.random() * 5; // 0-5 seconds delay
      
      particle.style.animation = `floatParticle ${duration}s ${delay}s infinite linear`;
      
      container?.appendChild(particle);
      particles?.push(particle);
    }

    // Cleanup function
    return () => {
      particles?.forEach(particle => {
        if (particle?.parentNode) {
          particle?.parentNode?.removeChild(particle);
        }
      });
    };
  }, []);

  return (
    <>
      <div ref={containerRef} className="fixed inset-0 overflow-hidden pointer-events-none z-0" />
      <style jsx>{`
        @keyframes floatParticle {
          0% {
            transform: translateY(100vh) translateX(0) rotate(0deg);
            opacity: 0;
          }
          10% {
            opacity: 0.6;
          }
          90% {
            opacity: 0.6;
          }
          100% {
            transform: translateY(-10vh) translateX(100px) rotate(360deg);
            opacity: 0;
          }
        }
      `}</style>
    </>
  );
};

export default FloatingParticles;